<script lang="ts" setup>
  interface Props {
    readonly errors?: string[]
  }

  const props = defineProps<Props>()
</script>

<template>
  <div
    v-if="errors"
    class="errors"
  >
    <span
      v-for="(error, i) in props.errors"
      :key="`error-${i}`"
      class="error"
    >
      {{ error }}
    </span>
  </div>
</template>

<style scoped>
  .errors {
    display: flex;
    flex-direction: column;
    margin-top: .25rem;

    .error {
      margin:  .25rem 0;
      color: var(--color-error);
      font-family: Open-Sans, sans-serif;
      font-size: 0.75em;
      font-weight: 400;
      hyphens: auto;
      line-height: inherit;
    }
  }
</style>
